var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #757575;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.25,65.75l1,2.5,8-2.5,10-11,4.5-5.5,2.5,10,3.5,3-4,4,3.5,2,6-2,5.5,2,1.5-1.5-3-5,5.5-5,1.5-6,6,2.5,5-3,1,7,6,5h3l1-3.5-5-5.5-1.5-8-3.5-3.5-4.5,1.5v-9l-6-4.5-13-1-8-3-6,1-7.5-.5,4.5-1.5,3.5-7.5-1-2-2.5,1.5v-2.5h-1.5l-4,4.5v-2l-1.5-1.5-3,3.5-1.5-7-2.5,1.5-1.5,6.5-3.5-7-1.5,.5v5l-2.5-2.5-1.5,3,5.5,7L1.75,31.25l1.5,3,7,1.5,5,4,6,1,3,2.5v7l-3,4.5-6,7.5-5,3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.75,50.75h-8l1.5,6,2.5,1,3.5-4.5,.5-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoose);
export default __webpack_public_path__ + "static/media/moose.a7a9fb9d5a59094b08a5d7e29dc12d8c.svg";
export { ForwardRef as ReactComponent };